import Vue from 'vue'
import CompanyProfile from './about/CompanyProfile'
import './about/company-profile.css'

Vue.config.productionTip = false

new Vue({
  el: '#about-app',
  render: h => h(CompanyProfile)
})



// WEBPACK FOOTER //
// ./src/about-main.js